export default __webpack_public_path__ + "static/media/favicon.9ccb5ec2.ico";